import { create } from 'zustand';

type UserCollectionState = {
  favoriteIds: Set<string>;
  subscriptionIds: Set<string>;
};

type UserCollectionActions = {
  setCollection: (favorites: string[], subscriptions: string[]) => void;
  addFavorite: (id: string) => void;
  removeFavorite: (id: string) => void;
  addSubscription: (id: string) => void;
  removeSubscription: (id: string) => void;
  isFavorite: (id: string) => boolean;
  isSubscribed: (id: string) => boolean;
};

type UserCollectionStore = UserCollectionState & UserCollectionActions;

export const useUserCollectionStore = create<UserCollectionStore>(
  (set, get) => ({
    favoriteIds: new Set(),
    subscriptionIds: new Set(),

    setCollection: (favorites, subscriptions) =>
      set({
        favoriteIds: new Set(favorites),
        subscriptionIds: new Set(subscriptions),
      }),

    addFavorite: id =>
      set(state => ({ favoriteIds: new Set(state.favoriteIds).add(id) })),

    removeFavorite: id =>
      set(state => {
        const next = new Set(state.favoriteIds);
        next.delete(id);
        return { favoriteIds: next };
      }),

    addSubscription: id =>
      set(state => ({
        subscriptionIds: new Set(state.subscriptionIds).add(id),
      })),

    removeSubscription: id =>
      set(state => {
        const next = new Set(state.subscriptionIds);
        next.delete(id);
        return { subscriptionIds: next };
      }),

    isFavorite: id => get().favoriteIds.has(id),

    isSubscribed: id => get().subscriptionIds.has(id),
  })
);
